export default function randomIdent() {
    return Math.random()
        .toString(36)
        .replace('0.', '')
}
